import angular from 'angular'
import './scheduled_configurations.service'
import moment from 'moment-timezone'

angular
  .module('admin.scheduled_configurations', ['admin.scheduled_configurations.service'])
  .controller('ScheduledConfigurationsCtrl', ScheduledConfigurationsCtrl)

/** @ngInject */
function ScheduledConfigurationsCtrl(UploadService, ScheduledConfigurationsService) {
  var vm = this

  vm.items = []
  vm.perPage = 25
  vm.isOpen = false
  vm.isOpen2 = false
  vm.startsAt = null
  vm.endsAt = null

  vm.openCalendar = function(e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function(e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.convertTimezone = function() {
    if (vm.startsAt) {
      vm.timezoneDatePublishedNY = moment(vm.startsAt)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDatePublishedLA = moment(vm.startsAt)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
    if (vm.endsAt) {
      vm.timezoneDate2PublishedNY = moment(vm.endsAt)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2PublishedLA = moment(vm.endsAt)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
  }

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    ScheduledConfigurationsService.list(vm.oldPage, 25).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].config_parse = JSON.parse(result.results[i].config)
      }

      console.log(result.results)

      vm.items = result.results
    })
  }

  load(1)

  vm.load = function() {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.send = function(item) {
    var message = angular.copy(item)
    delete message.ts
    delete message['ts-m']
    ScheduledConfigurationsService.update(message.id, message).then(
      function() {
        $('#myModalAdd').modal('hide')
        vm.load()
      },
      function(err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.add = function() {
    vm.message = {
      id: 0,
      config: "{'logoNavbar': '', logoNavbarTooltip: ''}",
      'ts-start': null,
      'ts-end': null,
    }
    vm.logoNavbar = ''
    vm.logoNavbarTooltip = ''
    vm.startsAt = null
    vm.endsAt = null
    $('#myModalAdd').modal('show')
  }

  vm.edit = function(item) {
    vm.message = angular.copy(item)
    vm.logoNavbar = ''
    vm.logoNavbarTooltip = ''
    if (vm.message.config) {
      var config = JSON.parse(vm.message.config)
      if (config && config.logoNavbar) {
        vm.logoNavbar = config.logoNavbar
      }
      if (config && config.logoNavbarTooltip) {
        vm.logoNavbarTooltip = config.logoNavbarTooltip
      }
    }
    vm.startsAt = new Date(vm.message['ts-start'] / 1000)
    vm.endsAt = new Date(vm.message['ts-end'] / 1000)
    vm.convertTimezone()
    delete vm.message.ts
    delete vm.message['ts-m']
    $('#myModalAdd').modal('show')
  }

  var isDate = function(date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.save = function() {
    var message = angular.copy(vm.message)
    if (!vm.logoNavbar) {
      swal('Please enter a Logo Navbar', '', 'error')
      return
    }

    if (!vm.logoNavbarTooltip) {
      swal('Please enter a Logo Navbar Tooltip', '', 'error')
      return
    }

    if (vm.startsAt) {
      if (isDate(vm.startsAt)) {
        var date = parseInt(new Date(vm.startsAt).getTime() + '000')
        message['ts-start'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      swal('Date field invalid.', '', 'error')
      return
    }

    if (vm.endsAt) {
      if (isDate(vm.endsAt)) {
        var date = parseInt(new Date(vm.endsAt).getTime() + '000')
        message['ts-end'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      swal('Date field invalid.', '', 'error')
      return
    }

    message.config = JSON.stringify({
      logoNavbar: vm.logoNavbar,
      logoNavbarTooltip: vm.logoNavbarTooltip,
    })

    if (message.id !== 0) {
      ScheduledConfigurationsService.update(message.id, message).then(
        function() {
          $('#myModalAdd').modal('hide')
          vm.load()
        },
        function(err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      ScheduledConfigurationsService.save(message).then(
        function() {
          $('#myModalAdd').modal('hide')
          vm.load()
        },
        function(err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.delete = function(item) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          ScheduledConfigurationsService.remove(item.id).then(
            function() {
              $('#myModalAdd').modal('hide')
              vm.load()
            },
            function(err) {
              swal(err.error.message, '', 'error')
            },
          )
        }
      },
    )
  }

  vm.loadImg = false
  vm.pathImg = null
  vm.uploadImg = function() {
    vm.loadImg = true
    // GET TYPE FILE
    var type = vm.pathImg.name.split('.')
    type = type[type.length - 1]

    UploadService.saveFixed(
      'website/public/assets/icons/logo',
      vm.pathImg,
      'logo_' + new Date().getTime() + '.' + type,
    ).then(function(fileName) {
      vm.loadImg = false
      if (
        window.location.href.indexOf('dev') !== -1 ||
        window.location.href.indexOf('localhost') !== -1
      ) {
        vm.logoNavbar =
          'https://imager.streetteam.dev/website/public/assets/icons/logo/' + fileName
      } else {
        vm.logoNavbar =
          'https://imager-prod.streetteam.dev/website/public/assets/icons/logo/' + fileName
      }
    })
  }
}
